import React from 'react';

const ConditionsGenerales = () => (
  <div className="cgv-page">
<h2>Conditions Générales de Vente et de Paiement</h2>

<p><strong>1. Réservation :</strong> Toute réservation sur notre site implique l'acceptation de ces conditions. Une confirmation de réservation vous sera envoyée par e-mail après validation du paiement.</p>

<p><strong>2. Paiement :</strong> Le paiement est effectué en ligne via une plateforme sécurisée. Les cartes acceptées sont : Visa, MasterCard, CIB, etc.</p>

<p><strong>3. Annulation :</strong> L’annulation est gratuite jusqu’à 48h avant la date d’arrivée. Au-delà, une nuit sera facturée. En cas de non-présentation, l’intégralité du séjour sera due.</p>

<p><strong>4. Sécurité des transactions :</strong> Les transactions sont protégées par SSL. Aucune donnée bancaire n’est stockée sur notre site.</p>

<p><strong>5. Données personnelles :</strong> Conformément à la loi 09-08, vous disposez d’un droit d’accès, de rectification et de suppression de vos données.</p>

<p><strong>6. Loi applicable :</strong> Les présentes conditions sont soumises à la législation algérienne.</p>

  </div>
);

export default ConditionsGenerales;
